<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7WmU5g/tc-custom/9780374722302.jpg?1724781542271" alt="This image is the cover for the book Likes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Likes
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A BEST BOOK OF THE YEAR: <i>Library Journal</i>, <i>Electric Literature</i>, The New York Public Library, <i>PopMatters</i></b><br/><b>A Finalist for the<i> Los Angeles Times</i> Book Prize and the Story Prize</b><br/><b><br/>National Book Award finalist Sarah Shun-lien Bynum’s highly anticipated return weaves together like and unlike, mythic and modern</b><br/><br/>In nine stories that range from the real to the unreal, strange to familiar, funny to frightening, Sarah Shun-lien Bynum reminds us why her wildly original debut, <i>Madeleine Is Sleeping</i>, and her masterful <i>Ms. Hempel Chronicles</i> have become contemporary classics--celebrated and beloved.<br/><br/>In a nimble dance of lightness and gravity, <i>Likes</i> explores the full range and contradictions of our contemporary moment. Through unexpected visitors, Waldorf school fairs, aging indie-film stars, the struggle to gain a foothold in the capitalist shell-game of work, the Instagram posts of a twelve-year-old—these stories of friendship and parenthood, celebrity and obsession, race and class and the passage of time, form an engrossing collection that is both otherworldly and suffused with the deceitful humdrum of everyday life.<br/><br/>For readers of Joy Williams, George Saunders, Lauren Groff, and Deborah Eisenberg, <i>Likes </i>helps us see into our unacknowledged desires and, in quick, artful, nearly invisible cuts, exposes the roots of our abiding terrors and delights.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Shun-lien Bynum
      </h2>
      
      <p class="authorDescription body article">Sarah Shun-lien Bynum is the author of the novels <I>Ms. Hempel Chronicles</I>, a finalist for the PEN/Faulkner Award, and <I>Madeleine Is Sleeping</I>, a finalist for the National Book Award and winner of the Janet Heidinger Kafka Prize. Her fiction has appeared in many magazines and anthologies, including the <I>New Yorker</I>, <I>Ploughshares</I>, <I>Tin House</I>, <I>The Best American Short Stories, </I>and the <I>O. Henry Prize Stories</I>. The recipient of a Whiting Writers’ Award and an NEA Fellowship, she was named one of “20 Under 40” fiction writers by the <I>New Yorker</I>. She lives in Los Angeles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1dff9d5c